/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faCreditCard } from '@fortawesome/pro-solid-svg-icons';
import { faCcVisa } from '@fortawesome/free-brands-svg-icons';
import {
  useUpdateStorageAccountCreditCard,
  useStorageAccountInfo,
} from '../queries';
import {
  formatExpDate,
  formatCreditCard,
  getCreditCardIssuerInfo,
} from '../../../../lib/helpers';

function StorageUpdatePayment() {
  const { data: accountInfoData } = useStorageAccountInfo();
  const cardUpdateHandler = useUpdateStorageAccountCreditCard();

  const { watch, reset, setValue } = useForm();

  const [displayCard, setDisplayCard] = useState({
    name: 'Visa',
    display: faCcVisa,
  });
  const [ready, setReady] = useState(false);

  console.log(ready);

  const expDate = watch('exp');
  const cardNumber = watch('cardNumber');

  useEffect(() => {
    if (accountInfoData?.creditCard) {
      const { firstName, lastName, address1, address2, city, state, zipCode } =
        accountInfoData.creditCard;

      reset({
        firstName,
        lastName,
        address1,
        address2,
        city,
        state,
        zipCode,
      });
      setReady(true);
    }
  }, [accountInfoData]);

  useEffect(() => {
    if (expDate) {
      const formattedExpDate = formatExpDate(expDate);
      setValue('exp', formattedExpDate);
    }
  }, [expDate]);

  useEffect(() => {
    if (cardNumber) {
      const detectedCard = getCreditCardIssuerInfo(
        parseInt(cardNumber.split('')[0], 10)
      );
      const formattedNumber = formatCreditCard(cardNumber, detectedCard.name);
      setValue('cardNumber', formattedNumber);
      if (displayCard !== detectedCard) {
        setDisplayCard(detectedCard);
      }
    }
  }, [cardNumber]);

  /*
  const onSubmit = (data) => {
    const validExpiration = validateExpDate(data.exp);
    const validCard = validateCreditCard(data.cardNumber, displayCard.name);
    if (!validExpiration) {
      setError('exp', { type: 'custom', message: 'Invalid expiration date.' });
    }
    if (!validCard) {
      setError('cardNumber', {
        type: 'custom',
        message: 'Invalid credit card number.',
      });
    }

    if (validExpiration && validCard) {
      const formattedNumber = data.cardNumber.replaceAll(' ', '');

      const firstStepDate = parse(`${data.exp}/01`, 'MM/yy/dd', new Date());
      const lastDay = lastDayOfMonth(firstStepDate);
      const formattedDate = format(lastDay, 'yyyy-MM-dd');

      const payload = {
        firstName: data.firstName,
        lastName: data.lastName,
        cardNumber: formattedNumber,
        cardExpDate: formattedDate,
        address1: data.address1,
        address2: data.address2,
        city: data.city,
        state: data.state,
        zipCode: data.zipCode,
      };

      cardUpdateHandler.mutate(payload);
    }
  };
  */

  if (cardUpdateHandler.isSuccess) {
    return <Navigate to="/portal/storage/payments" />;
  }

  return (
    <div className="portal-inner has-tabs">
      <Link to="/portal/storage/payments" className="back-link">
        <FontAwesomeIcon icon={faChevronLeft} />
        Return to Payments
      </Link>
      <Row>
        <Col md={6}>
          <div className="info-box">
            <div className="info-header">
              <h3>Temporarily Unavailable</h3>
              <FontAwesomeIcon icon={faCreditCard} />
            </div>
            <div className="info-content">
              <p>
                This feature is temporarily unavailable. Please contact our
                Accounting team at 1-800-442-6863 to update your payment
                information.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StorageUpdatePayment;
